let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5AX7Z")).then(() => parcelRequire('5DN5W'));